module.exports = __webpack_public_path__ + "static/media/joshua-earlesz.314904ba.jpg";